import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import Pills from '../../../../components/Pills';
import VerticalBarGraph from '../../../../components/Charts/VerticalBarGraph';
import Popin from '../../../../components/Charts/Popin';
import ExportButton from '../../../../components/Export';
import { I18n } from 'react-redux-i18n';

const DirectPriceCardContainer = styled.div`
  .chartContainer {
    margin-top: 25px;
  }

  svg .recharts-label-list tspan {
    fill: white !important;
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    font-size: 20px;
    font-family: ${(props) => props.theme.fonts.oswald};
    color: #202529;
    text-transform: uppercase;
  }

  .pillsContainer {
    margin-left: 40px;
    text-transform: none;
  }

  .keyIndicatorsIcon {
    margin-left: 10px;
  }
`;

export default class DirectPriceCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      activePill: 'ht_euro_price'
    };
  }

  renderHeader() {
    const { activePill } = this.state;
    const { wine, date, vintage } = this.props;
    return (
      <CardHeader
        title={
          <Title>
            <h1 className="title">{I18n.t('primeur.direct.title')}</h1>

            <div className="pillsContainer ignored-export">
              <Pills
                options={[
                  {
                    value: 'ht_euro_price',
                    label: I18n.t('primeur.direct.pillOptions.price')
                  },
                  {
                    value: 'market',
                    label: I18n.t('primeur.direct.pillOptions.market')
                  },
                  {
                    value: 'currency',
                    label: I18n.t('primeur.direct.pillOptions.currency')
                  }
                ].map((item) => ({
                  ...item,
                  active: activePill === item.value
                }))}
                onChange={({ value }) => this.setState({ activePill: value })}
              />
            </div>
          </Title>
        }
        fontSize="20px"
        rightComponents={
          <ExportButton
            jpg
            pdf
            xls
            path="/api/v1/clients/me/primeur/live/xls/"
            options={{ wine: wine, date: date, vintage: vintage }}
            name={`${I18n.t(
              'primeur.direct.title'
            )}-${wine}-${vintage}-${date}`}
            targetElement="#directVerticalGraph"
          />
        }
      />
    );
  }

  sortData(data) {
    const { activePill } = this.state;
    data.sort(function (a, b) {
      if (a && b && a[activePill] && b[activePill]) {
        if (isNaN(a[activePill]) || isNaN(b[activePill])) {
          return String(a[activePill]).localeCompare(String(b[activePill]));
        } else {
          return parseFloat(a[activePill]) === parseFloat(b[activePill])
            ? 0
            : parseFloat(a[activePill]) > parseFloat(b[activePill])
              ? 1
              : -1;
        }
      } else {
        return 0;
      }
    });
    return data;
  }

  formatData() {
    const { data, referenceLineValue } = this.props;
    let formattedData = [...data];
    formattedData = formattedData.map((item) => {
      if (!item) {
        return {};
      }
      return {
        ...item,
        value:
          referenceLineValue && referenceLineValue.currency_code !== 'EUR'
            ? item.local_price
            : item.ht_euro_price,
        name: item.store_name ? item.store_name : '-',
        market: item.store_markets ? item.store_markets[0] : '-',
        label: {
          value: item.ht_euro_price,
          currency: 'EUR',

          localCurrency:
            item.local_price !== item.ht_euro_price
              ? { value: item.local_price, currency: item.currency }
              : undefined
        }
      };
    });
    formattedData = this.sortData(formattedData);
    return [formattedData];
  }

  render() {
    const { referenceLineValue } = this.props;
    const { selectedBarInfo } = this.state;
    const formattedData = this.formatData();
    return (
      <DirectPriceCardContainer>
        <Card id="directVerticalGraph">
          {this.renderHeader()}

          <div className="chartContainer">
            <VerticalBarGraph
              currency="EUR"
              tooltip={false}
              customAxis={true}
              yAxisProps={{
                width: 250
              }}
              popin={(props) => this.setState({ selectedBarInfo: props })}
              data={formattedData}
              activeColor="#d35736"
              labels={['value']}
              singleBar
              popinContent={<Popin {...selectedBarInfo} />}
              referenceLineValue={referenceLineValue}
              colors={['#545d68']}
            />
          </div>
        </Card>
      </DirectPriceCardContainer>
    );
  }
}
